<ng-container *transloco="let t">
  <div class="bg-full-white pb-2">
    <pxc-back-navigation-button
      class="block"
      data-testid="back-button"
      [defaultUrl]="patientsBackUrl$ | async"
      [label]="t('Retour à la liste')" />
  </div>

  @if (isPatientStateLoaded$ | async) {
    @if (patient$ | async; as selectedPatient) {
      @let scrollHeaderTitle = scrollHeaderTitle$ | async;
      @let departmentId = departmentId$ | async;
      @let isMobile = isMobile$ | async;
      <header
        class="bg-full-white flex flex-col gap-4 py-2"
        data-testid="patient-header"
        tuiHeader="body-s"
        [scrollHeaderBackLink]="patientsBackUrl$ | async"
        [scrollHeaderTitle]="scrollHeaderTitle">
        <div class="flex w-full max-md:flex-col max-md:gap-3">
          <div class="flex flex-1 flex-col gap-3">
            <div class="flex items-center gap-5" data-testid="patient-data">
              <pxc-patient-avatar [patient]="selectedPatient" [size]="Size.LARGE" />
              <pxc-patient-data data-testid="patient-details" [patient]="selectedPatient" [size]="Size.LARGE">
                <pxc-patient-link-quick-action *showIfClientIsGamEnabled="selectedPatient" />

                @if (selectedPatient.isArchived) {
                  <div>
                    <pxc-archived-badge data-testid="archived-badge" />
                  </div>
                }
              </pxc-patient-data>
            </div>

            @if (selectedPatient.lastActivity; as lastActivity) {
              <p additional-data class="text-sm text-text-quaternary">
                {{ lastActivity | lastActivity }}
              </p>
            }
          </div>

          <aside tuiAccessories>
            <pxc-action-buttons
              data-testid="actions"
              optionButtonAppearance="outline"
              [actionButtons]="actionButtonsGroups"
              [actions]="patientActions"
              [entity]="selectedPatient" />
          </aside>
        </div>
        @if (isMobile) {
          <pxc-examinations-pane class="h-fit w-full" [isMobile]="true" />
        }
      </header>
      @if (selectedPatient.isArchived) {
        <div class="bg-full-white py-2">
          <pxc-archived-notification
            data-testid="archived-notification"
            [description]="t('Vous ne pouvez plus modifier ou ajouter de données à ce patient.')"
            [title]="t('Ce patient est archivé')" />
        </div>
      }
      <nav class="sticky animate-in fade-in" data-testid="tabs" tuiNavigationNav>
        <tui-tabs>
          @for (tab of tabs; track tab.link) {
            <button
              queryParamsHandling="merge"
              tuiTab
              type="button"
              [attr.data-testid]="tab.link"
              [queryParams]="tab.queryParams"
              [routerLink]="tab.link"
              [routerLinkActive]="['active']">
              {{ t(tab.title) }}
            </button>
          }
        </tui-tabs>
      </nav>
      <div class="relative flex gap-2 py-2 animate-in fade-in max-2xl:flex-col 2xl:gap-6">
        @if (!isMobile) {
          <pxc-examinations-pane class="sticky top-28 order-last h-fit w-80" [isMobile]="false" />
        }
        <div class="min-w-0 flex-1 grid-cols-[minmax(0,1fr)] overflow-x-clip" [tuiSlides]="slideDirection()">
          <router-outlet />
        </div>
      </div>
    } @else {
      <div class="flex flex-col items-center justify-center gap-4 text-center" data-testid="patient-not-found">
        <pxc-lottie-label animation="patientEmpty" [message]="t('Oups !')" />
        <p>{{ t("Désolé, nous n'avons pas trouvé le patient que vous cherchiez ...") }}</p>
        <a queryParamsHandling="merge" routerLink=".." tuiButton>
          {{ t('Retour à la liste des patients') }}
        </a>
      </div>
    }
  } @else {
    <pxc-loader data-testid="loading">{{ t('Chargement du patient ...') }}</pxc-loader>
  }
</ng-container>
